export const Categories={
    NATURE:{
        id:"natures",
        perPageLimit:46
    },
    STREET:{
        id:"street",
        perPageLimit:54
    },
    TRAVEL:{
        id:"travel",
        perPageLimit:40
    },
    WILDLIFE:{
        id:"wildlife",
        perPageLimit:10
    },
    PRODUCT:{
        id:"product",
        perPageLimit:40
    }

}